import { Component, ChangeDetectionStrategy, ViewEncapsulation, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogFullScreenComponentContent } from '../../../models/dialogs/dialog-full-screen';

@Component({
    selector: 'tr-receipt',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.Emulated,
    templateUrl: './tr-receipt.component.html',
    styleUrls: [ './tr-receipt.component.scss'],
})
export class TrReceiptComponent extends DialogFullScreenComponentContent {

    constructor(
        private dialogReference: MatDialogRef<TrReceiptComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        element: ElementRef,
    ) {
        super(element);
    }

    public dispose() {
        this.close(this.dialogReference, null);
    }
}
